import React from 'react';
//import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
//import classnames from 'classnames';
import { Link } from 'react-router-dom';
//import { getDataTab } from '../../components/UserFunctions'



class LOC extends React.Component {




    render() {
        return (
            <div data-test = 'kpiManagerLOCComponent'>


                <div className="container-fluid">
                    <div className="row">
                        <div className="col mt-5 mx-auto">
                            <div className="card">
                                <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                    <h2>KPI Manager -  List of components</h2>


                                </div>


                                <div className="card card-body">
                                    <table className="table table-bordered table-striped text-center">
                                        <thead className="table-head">
                                            <tr>
                                                <th style={{ textAlign: "center" }}>List of Components</th>
                                                <th style={{ textAlign: "center" }}></th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="table-row">
                                                <td style={{ textAlign: "center" }}>Camera</td>
                                                <th style={{ textAlign: "center"}}>
                                                <Link to={"/camera"}>
                                                    <button className="btn" style={{ color: "#ffffff", fontWeight: "bold"}}>Camera_KPI</button>
                                                </Link>
                                                </th>

                                            </tr>
                                            <tr className="table-row">
                                                <td style={{ textAlign: "center" }}>Lidar</td>
                                                <th style={{ textAlign: "center"}}>
                                                <Link to={"/lidar"}>
                                                    <button className="btn" style={{ textAlign: "center", color: "#ffffff", fontWeight: "bold" }}>Lidar_KPI</button>
                                                </Link>
                                                </th>

                                            </tr>
                                            <tr className="table-row">
                                                <td style={{ textAlign: "center" }}>Radar</td>
                                                <th style={{ textAlign: "center"}}>
                                                <Link to={"/radar"}>
                                                    <button className="btn" style={{ textAlign: "center", color: "#ffffff", fontWeight: "bold" }}>Radar_KPI</button>
                                                </Link>
                                                </th>
                                            </tr>


                                        </tbody>
                                    </table>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default LOC;
